import { render, staticRenderFns } from "./LoginCriar.vue?vue&type=template&id=10fe74bc&scoped=true&"
import script from "./LoginCriar.vue?vue&type=script&lang=js&"
export * from "./LoginCriar.vue?vue&type=script&lang=js&"
import style0 from "./LoginCriar.vue?vue&type=style&index=0&id=10fe74bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fe74bc",
  null
  
)

export default component.exports